import Grid from '@mui/material/Grid';
import { checkPermission } from '_controllers/helpers/checkPermission';
import DropdownAgentSelect from './DropdownAgentSelect';

const AgentAssignment = ({ handleChange, valueAgent, agentList }) => {
  if (!checkPermission('SUPPORT_TICKETS_SUPERVISOR')) return null;

  return (
    <Grid container direction='row' alignItems='center' className='m-b-10'>
      <Grid item size={{ xs: 3 }} textAlign='end'>
        <h5>Asignar a:</h5>
      </Grid>
      <Grid item size={{ xs: 9 }} paddingLeft={1}>
        <DropdownAgentSelect
          valueAgent={valueAgent}
          handleChange={handleChange}
          agentList={agentList}
        />
      </Grid>
    </Grid>
  );
};

export default AgentAssignment;
